<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header d-flex justify-content-between align-items-center">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Enrollment 
						</h6>
						<div class="d-flex align-items-center">
							<button v-b-modal.bv-modal.current-enrollment-modal class="btn btn-sm btn-secondary ml-2" @click="showCurrentEnrollment()">
								Show Current Enrollment
							</button>
						</div>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="studentCode" class="col-form-label">Student Code </label>
									<div class="input-group">
										<input type="text" v-model="currentEnrollmentData.student_code" class="form-control" id="studentCode" disabled>
									</div>
								</div>
								<div class="col-md-6">
									<label for="studentName" class="col-form-label">Student Name </label>
									<div class="input-group">
										<input type="text" v-model="currentEnrollmentData.student_name" class="form-control" id="studentName" disabled>
									</div>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="batchCode" class="col-form-label">Batch Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.batch_id" @blur="validationRule()" class="form-control" id="batchCode" @change="getFeeCode()">
										<option value="">Select Batch Code</option>
										<option v-for="batch in batchCodeList" :key="batch.id" :value="batch.id">{{ batch.code1}}{{ batch.code2 }}{{ batch.code3 }}</option>
									</select>
									<small class="text-danger">{{validationData.batch_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="feeCode" class="col-form-label">Fee Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.fee_id" @blur="validationRule()" class="form-control" id="feeCode" @change="getTerm()">
										<option value="">Select Fee Code</option>
										<option v-for="fee in feeCodeList" :key="fee.id" :value="fee.id">{{ fee.code }}</option>
									</select>
									<small class="text-danger">{{validationData.fee_id}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="paymentTerm" class="col-form-label">Payment Term <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.payment_terms_id" @blur="validationRule()" class="form-control" id="paymentTerm">
										<option value="">Select Payment Term</option>
										<option v-for="term in termList" :key="term.id" :value="term.id">{{ term.name }} - {{ term.payment_type.name }}</option>
									</select>
									<small class="text-danger">{{validationData.payment_terms_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="discount" class="col-form-label">Discount </label>
									<select v-model="enrollmentRequest.discount" @blur="validationRule()" @change="calculateDiscount()" class="form-control" id="discount">
										<option value="">Select Discount</option>
										<option v-for="discount in discountList" :key="discount.id" :value="discount.id">{{ discount.name }}</option>
									</select>
									<small class="text-danger">{{validationData.discount}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="parentName" class="col-form-label">Total Fees <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.total_fees" @blur="validationRule()" class="form-control" id="parentName">
									<small class="text-danger">{{validationData.total_fees}}</small>
								</div>
								<div class="col-md-6">
									<label for="discountAmount" class="col-form-label">Discount Amount</label>
									<input type="text" v-model="enrollmentRequest.discount_amount" readonly class="form-control" id="discountAmount">
									<small class="text-danger">{{validationData.discount_amount}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="enrollmentDate" class="col-form-label">Enrollment Date <span class="text-danger">*</span></label>
									<input type="date" v-model="enrollmentRequest.enrollment_date" @blur="validationRule()" class="form-control" id="enrollmentDate">
									<small class="text-danger">{{validationData.enrollment_date}}</small>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="current-enrollment-modal" title="Current Enrollment Details" size="lg" hide-footer scrollable>
			<template v-slot:default>
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-12">
							<div class="table-scroll-wrapper">
								<table class="table table-bordered">
								<thead>
									<tr>
										<th>Student Code</th>
										<th>Student Name</th>
										<th>Phone</th>
										<th>Age</th>
										<th>Gender</th>
										<th>Address</th>
										<th>Parent Name</th>
										<th>Parent Phone</th>
										<th>Enrollment Date</th>
										<th>Email</th>
										<th>Discount</th>
										<th>Batch</th>
										<th>Fee</th>
										<th>Payment Terms</th>
										<th>Total Fees</th>
										<th>Discount Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ currentEnrollmentData.student_code }}</td>
										<td>{{ currentEnrollmentData.student_name }}</td>
										<td>{{ currentEnrollmentData.phone }}</td>			
										<td>{{ currentEnrollmentData.age }}</td>
										<td>{{ currentEnrollmentData.gender }}</td>
										<td>{{ currentEnrollmentData.address }}</td>
										<td>{{ currentEnrollmentData.parent_name }}</td>
										<td>{{ currentEnrollmentData.parent_phone }}</td>
										<td>{{ currentEnrollmentData.enrollment_date }}</td>
										<td>{{ currentEnrollmentData.email }}</td>
										<td>{{ currentEnrollmentData.discount }}</td>
										<td>{{ currentEnrollmentData.batch }}</td>
										<td>{{ currentEnrollmentData.fee }}</td>
										<td>{{ currentEnrollmentData.payment_terms }}</td>
										<td>{{ currentEnrollmentData.total_fees }}</td>
										<td>{{ currentEnrollmentData.discount_amount }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						</div>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enrollmentCreate',
		metaInfo: {
            title: "Enrollment Create",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				batchCodeList: [],
				discountList: [],
				feeCodeList: [],
				termList: [],
				originalFeeAmount: 0,
				currentEnrollmentData: {
					id: "",
					student_code: "",
					student_name: "",
					phone: "",
					age: "",
					gender: "",
					address: "",
					parent_name: "",
					parent_phone: "",
					enrollment_date: "",
					email: "",
					discount: "",
					batch: "",
					fee: "",
					payment_terms: "",
					total_fees: "",
					discount_amount: 0,
				},
				enrollmentRequest: {
					student_code: "",
					student_name: "",
					phone: "",
					age: "",
					gender: "",
					address: "",
					parent_name: "",
					parent_phone: "",
					enrollment_date: "",
					email: "",
					discount: "",
					batch_id: "",
					fee_id: "",
					payment_terms_id: "",
					total_fees: "",
					discount_amount: 0,
				},
				filter: {
					page: "",
					per_page: "",
					sort_direction: "",
					sort_by: "",
					search_batch: "",
					search_fee: "",
					search_student: "",
					status: "",
					date_from: "",
					date_to: "",
				},
				validationData: {
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				enrollmentStoreAction: 'enrollmentStoreAction',
				enrollmentDetailAction: 'enrollmentDetailAction',
				getBatchCodeAction: 'getBatchCodeAction',
				getDiscountAction: 'getDiscountAction',
				getFeeCodeAction: 'getFeeCodeAction',
				getTermAction: 'getTermAction',
			}),
			async getEnrollmentDetail(){
				let option = {
					id: this.id
				}
				await this.enrollmentDetailAction(option).then(async res => {
					console.log("Enrollment Detail Response:", res)
					this.currentEnrollmentData.id = res.data.id || ""
					this.currentEnrollmentData.student_code = res.data.student.student_code || ""
					this.currentEnrollmentData.student_name = res.data.student.name || ""
					this.currentEnrollmentData.phone = res.data.student.phone || ""
					this.currentEnrollmentData.age = res.data.student.age || ""
					this.currentEnrollmentData.gender = res.data.student.gender || ""
					this.currentEnrollmentData.address = res.data.student.address || ""
					this.currentEnrollmentData.parent_name = res.data.student.parent_name || ""
					this.currentEnrollmentData.parent_phone = res.data.student.parent_phone || ""
					this.currentEnrollmentData.enrollment_date = res.data.enrollment_date || ""
					this.currentEnrollmentData.email = res.data.student.email || ""
					this.currentEnrollmentData.discount = res.data.discount? res.data.discount.name : ""
					this.currentEnrollmentData.batch = res.data.batch? res.data.batch.code1 + res.data.batch.code2 + res.data.batch.code3 : ""
					this.currentEnrollmentData.fee = res.data.fee? res.data.fee.code : ""
					this.currentEnrollmentData.payment_terms = res.data.payment_terms? res.data.payment_terms.name : ""
					this.currentEnrollmentData.total_fees = res.data.amount || ""
					this.currentEnrollmentData.discount_amount = res.data.discount_amount || 0

					
					console.log("Current Enrollment Data:", this.currentEnrollmentData.data.student)
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getDiscount(){
				await this.getDiscountAction().then(res => {
					this.discountList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getBatchCode(){
				await this.getBatchCodeAction().then(res => {
					this.batchCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getFeeCode(){
				// Reset fee selection when batch changes
				this.enrollmentRequest.fee_id = "";
				this.enrollmentRequest.total_fees = "";
				this.enrollmentRequest.discount_amount = 0;
				this.feeCodeList = [];
				this.termList = [];

				let option = {
					batch_id: this.enrollmentRequest.batch_id
				}
				await this.getFeeCodeAction(option).then(res => {
					this.feeCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getTerm(){
				// Reset payment term when fee changes
				this.enrollmentRequest.payment_terms_id = "";
				
				// Get the selected fee amount and recalculate discount
				this.getFeeAmount();
				
				let option = {
					fee_id: this.enrollmentRequest.fee_id
				}
				await this.getTermAction(option).then(res => {
					this.termList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			getFeeAmount(){
				if(this.enrollmentRequest.fee_id && this.feeCodeList.length > 0) {
					const selectedFee = this.feeCodeList.find(fee => fee.id == this.enrollmentRequest.fee_id);
					if(selectedFee) {
						// Set the original fee amount
						const feeAmount = selectedFee.amount || selectedFee.fee_amount || 0;
						this.enrollmentRequest.total_fees = feeAmount;
						this.originalFeeAmount = feeAmount;
						
						// Recalculate discount if discount is already selected
						this.calculateDiscount();
					}
				} else {
					// No fee selected, reset amounts
					this.enrollmentRequest.total_fees = "";
					this.enrollmentRequest.discount_amount = 0;
				}
			},
			calculateDiscount(){
				const originalAmount = this.originalFeeAmount;
				console.log(this.enrollmentRequest.discount)
				if(this.enrollmentRequest.discount && this.discountList.length > 0 && this.enrollmentRequest.discount != "") {
					const selectedDiscount = this.discountList.find(discount => discount.id == this.enrollmentRequest.discount);
					if(selectedDiscount) {
						let discountAmount = 0;
						
						if(selectedDiscount.discount_type === 'percentage') {
							// Calculate percentage discount
							discountAmount = (originalAmount * selectedDiscount.discount_value) / 100;
						} else if(selectedDiscount.discount_type === 'fixed') {
							// Calculate fixed discount
							discountAmount = selectedDiscount.discount_value;
						}
						
						// Ensure discount doesn't exceed original amount
						if(discountAmount > originalAmount) {
							discountAmount = originalAmount;
						}
						
						this.enrollmentRequest.discount_amount = discountAmount;
						this.enrollmentRequest.total_fees = originalAmount - discountAmount;
					}
				} else {
					console.log("No discount selected")
					console.log(originalAmount)
					// No discount selected, reset to original amount
					this.enrollmentRequest.discount_amount = 0;
					this.enrollmentRequest.total_fees = this.originalFeeAmount;
				}
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('id', this.currentEnrollmentData.id);
				formData.append('student_code', this.currentEnrollmentData.student_code);
				formData.append('student_name', this.currentEnrollmentData.student_name);
				formData.append('phone', this.currentEnrollmentData.phone);
				formData.append('age', this.currentEnrollmentData.age);
				formData.append('gender', this.currentEnrollmentData.gender);
				formData.append('address', this.currentEnrollmentData.address);
				formData.append('email', this.currentEnrollmentData.email);
				formData.append('parent_name', this.currentEnrollmentData.parent_name);
				formData.append('parent_phone', this.currentEnrollmentData.parent_phone);
				formData.append('enrollment_date', this.enrollmentRequest.enrollment_date);
				formData.append('discount_id', this.enrollmentRequest.discount);
				formData.append('batch_id', this.enrollmentRequest.batch_id);
				formData.append('fee_id', this.enrollmentRequest.fee_id);
				formData.append('payment_terms_id', this.enrollmentRequest.payment_terms_id);
				formData.append('total_fees', this.enrollmentRequest.total_fees);
				formData.append('discount_amount', this.enrollmentRequest.discount_amount);

				await this.enrollmentStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: '/enrollment-list', 
					query: {
						page: 1, 
						per_page: 10,
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search_batch: '',
						search_fee: '',
						search_student: '',
						status: '',
						date_from: '',
						date_to: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.enrollmentRequest.code1 == "") {
					this.validationData.code1 = "The code1 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code1 = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.code2 == "") {
					this.validationData.code2 = "The code2 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code2 = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.code3 == "") {
					this.validationData.code3 = "The code3 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code3 = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.start_date == "") {
					this.validationData.start_date = "The start date field is required."
					isValidation.push(true)
				} else {
					this.validationData.start_date = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.end_date == "") {
					this.validationData.end_date = "The end date field is required."
					isValidation.push(true)
				} else {
					this.validationData.end_date = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
			this.filter.per_page = this.$route.query.per_page
			this.filter.sort_direction = this.$route.query.sort_direction
			this.filter.sort_by = this.$route.query.sort_by
			this.filter.search_batch = this.$route.query.search_batch || ''
			this.filter.search_fee = this.$route.query.search_fee || ''
			this.filter.search_student = this.$route.query.search_student || ''
			this.filter.status = this.$route.query.status || ''
			this.filter.date_from = this.$route.query.date_from || ''
			this.filter.date_to = this.$route.query.date_to || ''
			this.id = this.$route.query.id || ''

			await this.getEnrollmentDetail()
			await this.getBatchCode()
			await this.getDiscount()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}

	.table-scroll-wrapper {
		max-height: 400px; /* adjust as needed */
		overflow-y: auto;
	}
</style>